















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Getter, namespace } from 'vuex-class';

/**
 * Helpers
 */
import { logout } from '@/utils/auth';

/**
 * Utils
 */
import { getInitials, getFullName } from '@/utils/users-helpers';

/**
 * Components
 */
import AppNavigationDrawer from '@/components/_global/NavigationDrawer.vue';
import ChangePasswordDialog from '@/components/profile/components/ChangePasswordDialog.vue';

/**
 * API
 */
import adminAPI from '@/api/admin';
import usersAPI from '@/api/users';
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { ItemCategories } from '@/components/_global/NavigationDrawer.vue';
import { SettingsResponseModel } from '@/api/settings';
import { IsAuthorizedType } from './components/_global/permissions/store';

/**
 * VueX Modules
 */
const clientSettingsModule = namespace('settings');
const agentPermissionsModule = namespace('permissions');


const isAgentAuthorized = async function (to: any, context: Vue): Promise<boolean> {
	const store = context.$store;
	if (!store.state.permissions.agentPermissions) {
		try {
			await store.dispatch('permissions/fetchAgentPermissions');
		}
		catch (e) {
			return false;
		}
	}

	if (to.meta.enabled != null && store.state.permissions.agentPermissions && !to.meta.isAuthorized(store.getters['permissions/isAuthorized'])) {
		return false;
	}

	return true;
};

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteLeave',
	'beforeRouteUpdate'
]);

@Component({
	components: {
		AppNavigationDrawer,
		ChangePasswordDialog
	}
})
export default class AppAgentLayout extends Vue {
	$refs!: {
		changePasswordDialog: ChangePasswordDialog,
	};

	/** Injections */
	getInitials = getInitials;
	getFullName = getFullName;
	authenticationAPI = authenticationAPI;

	/** VueX - Settings */
	@clientSettingsModule.Getter
	settings!: SettingsResponseModel;

	/** VueX - Agent Permissions */
	@agentPermissionsModule.Getter
	isAuthorized!: IsAuthorizedType;

	@agentPermissionsModule.Action
	fetchAgentPermissions!: () => Promise<void>;

	/** Propriétés */
	@Prop()
	title!: string;

	/** Attributs */
	aboutInfos: any = null;
	currentUser: any = null;
	drawer: boolean | null = null;
	get itemCategories(): ItemCategories[] {
		return [
			{
				text: 'menu.categories.management',
				items: [
					// { icon: 'fa-sliders-h', link: '/admin', text: 'Réservations' },
					{
						icon: 'calendar_today', text: 'menu.booking_time',
						items: [{
							icon: 'calendar_today', link: '/admin/bookings', text: 'menu.bookings_list',
							enabled: (settings, isAuthorized) => settings.booking.enableBooking && isAuthorized((x: any) => x.canBookForUsers)
						}]
					},
					{
						icon: 'fa-calendar-alt', text: 'menu.booking_resources',
						enabled: (settings) => settings.bookingResources.enable,
						items: [{
							icon: 'fa-stream', link: '/admin/time_ranges/editor', text: 'menu.time_ranges_editor',
							enabled: (settings, isAuthorized) => isAuthorized((x) => x.canEditTimeRanges),
						}, {
							icon: 'fas fa-calendar-check', link: '/admin/booking_resources/editor', text: 'menu.booking_editor',
							enabled: (settings, isAuthorized) => isAuthorized((x) => x.canBookForUsers),
						}]
					},
				]
			},
			{
				text: 'menu.categories.settings',
				items: [
					{
						icon: 'fa-sliders-h', link: '/admin/settings/basic', text: 'menu.settings_basic',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canEditBasicParameters),
					},
					{
						icon: 'fa-palette', link: '/admin/settings/customization', text: 'menu.settings_customization',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canEditCustomizationParameters),
					},
					{
						icon: 'fa-cog', link: '/admin/settings/advanced', text: 'menu.settings_advanced',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canEditAdvancedParameters),
					},
					{
						icon: 'fa-cogs', link: '/admin/settings/features', text: "menu.settings_features",
						enabled: (settings, isAuthorized) => isAuthorized((x) => false),
					},
				]
			},
			{
				text: 'menu.categories.supervision',
				items: [
					{
						icon: 'fa-file-alt', link: '/admin/logs', text: 'menu.logs',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canViewApplicationLogs),
					},
					{
						icon: 'fa-file', link: '/admin/logs/synchro', text: 'menu.logs_synchro',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canViewSynchronizationLogs),
					},
					{
						icon: 'sync', link: '/admin/synchronization', text: 'menu.synchronization',
						enabled: (settings, isAuthorized) => isAuthorized((x) => x.canViewSynchronizationHistory),
					},
				]
			},
		];
	}

	/** Méthodes */
	async created() {
		await this.fetchAgentPermissions();
		this.aboutInfos = await adminAPI.getAboutInfos();
		this.currentUser = await usersAPI.getCurrent();
	}

	handleOpenChangePasswordDialog() {
		this.$refs.changePasswordDialog.open();
	}

	async handleLogout() {
		await logout();
	}

	async beforeRouteEnter(to: any, from: any, next: any) {
		next(async (vm: any) => {
			const gR = await isAgentAuthorized(to, vm);
			if (!gR) {
				return vm.$router.push('/');
			}
		});
	}
	async beforeRouteUpdate(to: any, from: any, next: any) {
		const gR = await isAgentAuthorized(to, this);
		if (!gR) {
			return this.$router.push('/');
		}
		next();
	}
}
